import { ChevronDown, ChevronUp } from 'lucide-react'
import { ReactNode } from 'react'

interface FilterSectionProps {
  title: string
  sectionKey: string
  isExpanded: boolean
  onToggle: (sectionKey: string) => void
  children: ReactNode
}

const FilterSection = ({ title, sectionKey, isExpanded, onToggle, children }: FilterSectionProps) => {
  const handleToggle = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    onToggle(sectionKey)
  }

  return (
    <div className="border-b border-gray-200 last:border-b-0">
      <button
        onClick={handleToggle}
        className="w-full flex items-center justify-between py-4 text-left hover:bg-gray-50 -mx-2 px-2 rounded transition-colors"
        type="button"
      >
        <h4 className="font-semibold text-gray-900">{title}</h4>
        {isExpanded ? (
          <ChevronUp className="h-5 w-5 text-gray-500 flex-shrink-0" />
        ) : (
          <ChevronDown className="h-5 w-5 text-gray-500 flex-shrink-0" />
        )}
      </button>
      {isExpanded && (
        <div className="pb-4" onClick={(e) => e.stopPropagation()}>
          {children}
        </div>
      )}
    </div>
  )
}

export default FilterSection

